import FallbackVisitor from "../FallbackVisitor.js";
const $schemaVisitor = FallbackVisitor;
export default $schemaVisitor;